import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface GetBaijiahaoActivityParams extends ActiomCommonParams {
    token: string;
}

export interface ActivityData {
    id: string;
    task_name: string;
}

export type PublishAction = CommonAction<GetBaijiahaoActivityParams, ActivityData[]>;

export const getBaijiahaoActivity: PublishAction = async (_task, params) => {
    const cookies = params.cookies ?? [];

    const http = new Http({
        headers: {
            cookie: cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            token: params.token,
        },
    });

    const res = await http.api<{ data: { list: ActivityData[] } }>({
        method: "get",
        url: "https://baijiahao.baidu.com/author/eco/tasksystem/getSquareMissionList",
        params: {
            page_no: 1,
            page_size: 18,
            article_type: 1,
            task_attend: 1,
            task_origin: "market",
            task_type: -1,
            from: "pc_edit",
        },
    });

    return success(res?.data?.list ?? []);
};
